exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_taskDetailsCell__dEHne{display:flex}.style_blockIcon__36wOe{opacity:.2;font-size:2.5rem}.style_cell__357lZ{padding:.5rem}", ""]);

// exports
exports.locals = {
	"taskDetailsCell": "style_taskDetailsCell__dEHne",
	"blockIcon": "style_blockIcon__36wOe",
	"cell": "style_cell__357lZ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/areas/projects/components/ProjectDashboard/DashboardCell/style.less
// module id = 1699
// module chunks = 8